import React from 'react'
import PropTypes from 'prop-types'

// @mui
import { Box, Typography } from '@mui/material'

// core
import { withLang } from '_core/hocs/withLang'

import { TopicList } from '_core/views/MessagesSplash/TopicList'
import { TopicView } from '_core/views/MessagesSplash/TopicView'
import { useMessengerTopic } from '_core/views/MessagesSplash/util.js'

import './Messenger.css'

const RawMessagerDesktop = (props) => {
  const { topics, topicId, selectedMessageId, topicSubject, getLangString: l } = props;
  const { selectedTopic, viewMessageId, selectTopic } = useMessengerTopic(
    topics,
    topicId,
    selectedMessageId,
    topicSubject
  );

  return (
    <div>
      <div>
        <Typography variant="h6">
          {l('r.soobscheniya')}
        </Typography>
      </div>
      <div className="messenger">
        <TopicList topics={topics} initialSelection={selectedTopic} onSelect={selectTopic} />
        {(selectedTopic != null) ? (
          <TopicView
            key={`${selectedTopic.id}:${viewMessageId ?? 'last'}`}
            topicId={selectedTopic.id}
            selectedMessageId={viewMessageId}
          />
        ) : (<Box />)}
      </div>
    </div>
  );
}

RawMessagerDesktop.defaultProps = {}

RawMessagerDesktop.propTypes = {
  // self props
  topicId: PropTypes.number,
  selectedMessageId: PropTypes.number,
  topicSubject: PropTypes.string,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const MessagerDesktop = withLang(RawMessagerDesktop)
